"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValue = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var type_guard_1 = require("../../utils/type-guard");
var ConditionControl_1 = __importDefault(require("../ConditionControl/ConditionControl"));
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var ConditionsControl_styles_1 = require("./ConditionsControl.styles");
var Button_1 = __importDefault(require("../Button/Button"));
exports.defaultValue = {
    entries: [
        {
            field: "content_id",
            compare: "=",
            value: "",
        }
    ],
    relation: "AND",
};
var ConditionsControl = function (_a) {
    var _b = _a.labels, labels = _b === void 0 ? {
        and: "und",
        or: "oder",
        addField: "+ Bedingung",
        addGroup: "+ Gruppe",
    } : _b, conditions = _a.conditions, onChange = _a.onChange, _c = _a.className, className = _c === void 0 ? "" : _c;
    var styles = (0, ConditionsControl_styles_1.useStyles)();
    var handleRelationClick = function () {
        var draft = (0, cloneDeep_1.default)(conditions);
        draft.relation = draft.relation == "AND" ? "OR" : "AND";
        onChange(draft);
    };
    var handleAddEntryClick = function () {
        var draft = (0, cloneDeep_1.default)(conditions);
        draft.entries.push({
            field: "content_id",
            compare: "=",
            value: "",
        });
        onChange(draft);
    };
    var handleAddGroupClick = function () {
        var draft = (0, cloneDeep_1.default)(conditions);
        draft.entries.push({
            relation: "OR",
            entries: [
                {
                    field: "content_id",
                    compare: "=",
                    value: "",
                }
            ],
        });
        onChange(draft);
    };
    var handleDelete = function (index) { return function () {
        var draft = (0, cloneDeep_1.default)(conditions);
        draft.entries.splice(index, 1);
        onChange(draft);
    }; };
    var relation = conditions.relation, entries = conditions.entries;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(styles.component, " ").concat(className) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(styles.relation, " ").concat(styles["relation_".concat(relation == "AND" ? "and" : "or")]) }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ className: styles.relationButton, onClick: handleRelationClick }, { children: conditions.relation == "AND" ? labels.and : labels.or })) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.entries }, { children: [entries.map(function (entry, index) {
                        return (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.entry }, { children: [(0, type_guard_1.isCondition)(entry) ? (0, jsx_runtime_1.jsx)(ConditionControl_1.default, { condition: entry, onChange: function (value) {
                                        var draft = (0, cloneDeep_1.default)(conditions);
                                        draft.entries[index] = value;
                                        onChange(draft);
                                    } }) : null, (0, type_guard_1.isConditions)(entry) ? (0, jsx_runtime_1.jsx)(ConditionsControl, { conditions: entry, onChange: function (value) {
                                        var draft = (0, cloneDeep_1.default)(conditions);
                                        draft.entries[index] = value;
                                        onChange(draft);
                                    } }) : null, entries.length > 1 ?
                                    (0, jsx_runtime_1.jsx)("div", __assign({ className: styles.entryControls }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: "error", className: styles.entryDelete, onClick: handleDelete(index) }, { children: "X" })) }))
                                    :
                                        null] }), index);
                    }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.addWrapper }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: "outline", className: styles.addEntryButton, onClick: handleAddEntryClick }, { children: labels.addField })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: "outline", className: styles.addEntryButton, onClick: handleAddGroupClick }, { children: labels.addGroup }))] }))] }))] })));
};
exports.default = ConditionsControl;
